import React from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import Home from "./pages/Home/Home";
import Service from "./pages/services/services"
import Header from "./pages/Header";
function App() {
  return (
    <BrowserRouter>
    <Header/>
    <Routes>
      <Route path = '/' element = {<Home/>} />
      <Route path='/services' element={<Service/>} />
    </Routes>
    </BrowserRouter>
  );
}

export default App;